'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var IndustryCard = require('./IndustryCard.js');
var IndustrySelection = require('./IndustrySelection.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var IndustryChoice =
/*#__PURE__*/
function (_PureComponent) {
  inherits(IndustryChoice, _PureComponent);

  function IndustryChoice(props) {
    var _this;

    classCallCheck(this, IndustryChoice);

    _this = possibleConstructorReturn(this, getPrototypeOf(IndustryChoice).call(this, props));
    _this.state = {
      editing: false
    };
    return _this;
  }

  createClass(IndustryChoice, [{
    key: "industrySelected",
    value: function industrySelected(selectedIndustry) {
      return ObjectHelper.isPresent(selectedIndustry) && selectedIndustry.id != null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          popular_service_categories = _this$props.popular_service_categories,
          other_service_categories = _this$props.other_service_categories,
          selectedIndustry = _this$props.selectedIndustry,
          _onIndustrySelected = _this$props.onIndustrySelected,
          onOtherSelected = _this$props.onOtherSelected;

      if (this.industrySelected(selectedIndustry) && !this.state.editing) {
        return React__default["default"].createElement(Grid["default"], {
          container: true,
          justify: "center",
          alignItems: "center",
          alignContent: "center"
        }, React__default["default"].createElement(IndustryCard, {
          industry: selectedIndustry,
          name: selectedIndustry.name,
          icon: IndustrySelection.icons[selectedIndustry.asset_id] || IndustrySelection.icons['OTHER'],
          onClick: function onClick() {},
          isSelected: true
        }), React__default["default"].createElement(Grid["default"], {
          item: true,
          xs: 12,
          style: {
            textAlign: 'center'
          }
        }, React__default["default"].createElement(Button["default"], {
          color: "primary",
          onClick: function onClick() {
            _this2.setState({
              editing: true
            });
          }
        }, "Edit")));
      } else {
        return React__default["default"].createElement(IndustrySelection["default"], {
          popular_service_categories: popular_service_categories,
          other_service_categories: other_service_categories,
          onIndustrySelected: function onIndustrySelected(industry) {
            _onIndustrySelected(industry);

            _this2.setState({
              editing: false
            });
          },
          selectedIndustry: selectedIndustry,
          onOtherSelected: onOtherSelected
        });
      }
    }
  }]);

  return IndustryChoice;
}(React.PureComponent);
IndustryChoice.defaultProps = {
  popular_service_categories: [],
  other_service_categories: [],
  onIndustrySelected: function onIndustrySelected() {},
  selectedIndustry: {},
  onOtherSelected: function onOtherSelected() {}
};

module.exports = IndustryChoice;
